import axios from "axios";
import jwt_decode from "jwt-decode";
import { getItem, removeItem } from "./LocalStorage";
import { URL_LOGIN, LOCAL_STORAGE_NAME } from "./config";
const config = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
  },
};
const qs = require("qs");

export function hasAuthentificated() {
  const token = getItem(LOCAL_STORAGE_NAME);
  const IsValid = token ? tokenIsValid(token) : false;

  if (!IsValid) removeItem(LOCAL_STORAGE_NAME);

  return IsValid;
}

export function getType() {
  return getItem("type");
}

export function getTokenData() {
  const token = getItem(LOCAL_STORAGE_NAME);
  const { data } = jwt_decode(token);
  return data;
}

export function login(credentials) {
  return axios.post(URL_LOGIN, qs.stringify({ ...credentials }, config));
}

export function logout() {
  removeItem(LOCAL_STORAGE_NAME);
  window.location.href = "/login";
}

export function tokenIsValid(token) {
  try {
    const { exp } = jwt_decode(token); // date d'expiration en milliseconde
    if (exp * 1000 > new Date().getTime()) return true;
    else return false;
  } catch (error) {
    return false;
  }
}

export function securityGestionnaire(clientId) {
  const { user_id } = getTokenData();
  if (parseInt(user_id) !== parseInt(clientId)) {
    logout();
  }
}

export function securitySalarie(salarieId) {
  const { user_id } = getTokenData();
  if (parseInt(user_id) !== parseInt(salarieId)) {
    logout();
  }
}
